// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingTimeInfo_root__3v7dq","bookingInfo":"BookingTimeInfo_bookingInfo__1qA-p","dateSection":"BookingTimeInfo_dateSection__2yQcx"};